import { render, staticRenderFns } from "./listXw.vue?vue&type=template&id=2e7dc2f2&scoped=true&"
import script from "./listXw.vue?vue&type=script&lang=js&"
export * from "./listXw.vue?vue&type=script&lang=js&"
import style0 from "./listXw.vue?vue&type=style&index=0&id=2e7dc2f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7dc2f2",
  null
  
)

export default component.exports